
'use strict'

if (process.env.NODE_ENV === 'production') {
  module.exports = require('./brazilian-utils.cjs.production.min.js')
} else {
  module.exports = require('./brazilian-utils.cjs.development.js')
}
